import { createI18n } from 'vue-i18n'
import pl from './locales/pl.json'
import en from './locales/en.json'
import fr from './locales/fr.json'
import es from './locales/es.json'
import de from './locales/de.json'
import it from './locales/it.json'
import pt from './locales/pt.json'
import cs from './locales/cs.json'
import nl from './locales/nl.json'
import sv from './locales/sv.json'
import da from './locales/da.json'
import hu from './locales/hu.json'
import ro from './locales/ro.json'
import no from './locales/no.json'
import lt from './locales/lt.json'
import hr from './locales/hr.json'
import fi from './locales/fi.json'

// Get locale from localStorage or default to 'pl'
const getDefaultLocale = (): string => {
  try {
    const userInitData = localStorage.getItem('user_init_data')
    if (userInitData) {
      const data = JSON.parse(userInitData)
      return data.lang || 'pl'
    }
  } catch (error) {
    console.error('Error reading locale from localStorage:', error)
  }
  return 'pl'
}

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getDefaultLocale(), // Default locale from localStorage or 'pl'
  fallbackLocale: 'pl',
  messages: {
    pl,
    en,
    fr,
    es,
    de,
    it,
    pt,
    cs,
    nl,
    sv,
    da,
    hu,
    ro,
    no,
    lt,
    hr,
    fi
  },
  globalInjection: true // Enable global $t helper
})

export default i18n
